import { render, staticRenderFns } from "./feeConfigDetailHis.vue?vue&type=template&id=d2ee7c5a&scoped=true"
import script from "./feeConfigDetailHis.vue?vue&type=script&lang=js"
export * from "./feeConfigDetailHis.vue?vue&type=script&lang=js"
import style0 from "./feeConfigDetailHis.vue?vue&type=style&index=0&id=d2ee7c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ee7c5a",
  null
  
)

export default component.exports